import type { ReactNode, FC } from 'react';

interface Props {
  className?: string;
  renderFooter: (footerData: any) => ReactNode;
  footerData: any;
}

const TableFooter: FC<Props> = ({
  className,
  footerData,
  renderFooter,
}) => {
  return <tfoot className={className}>{renderFooter(footerData)}</tfoot>;
};
TableFooter.displayName = 'TableFooter';

export default TableFooter;
